import { Container } from "reactstrap";
import BackLink from "../../../../components/Common/BackLink";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";

interface Props {
    title: string;
    serialNumber: string;
    isDisabled?: boolean;
    onPrev?: (_data?: any) => void;
}

const HeaderBox = ({ onPrev = undefined, title, serialNumber, isDisabled = false }: Props) => {
    return (
        <>
            {onPrev != undefined &&<BackLink onClick={onPrev} disabled={isDisabled}/>}

            <Container fluid className="mt-4 d-flex justify-content-between">
                <Breadcrumbs title={title} />
                Serial number: {serialNumber}
            </Container>
        </>
    );
};

export default HeaderBox;
